// 创建文件zh/index.js
const zh = {
    navbar:{
        home:"首页",
        product:"产品介绍"
    }
  }
  export default zh